import script from "./CustomResourceApplyYNGX.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomResourceApplyYNGX.vue?vue&type=script&setup=true&lang=ts"

import "./CustomResourceApplyYNGX.vue?vue&type=style&index=0&id=559bee15&lang=less&scope=true"

const __exports__ = script;

export default __exports__